<template>
  <div class="footer-line">
    <div class="footer">
      <b-container fluid>
        <b-row>
          <b-col xl="4" class="d-sm-none d-xl-block">
            <div class="foot-left flex flex-column align-center">
              <div class="logo flex flex-column align-center">
                <img src="../assets/image/icon.png" />
                <span>国家碳计量中心（福建）</span>
              </div>
              <div class="phone">
                <img src="../assets/image/icon3.png" />
                <span>{{ concatInfo.company_phone }}</span>
              </div>
              <div class="qrcode flex flex-column align-center">
                <img src="../assets/image/icon4.jpg" />
                <span>关注我们</span>
              </div>
            </div>
          </b-col>
          <b-col sm="4" class="d-sm-block d-xl-none">
            <div class="sm-foot-left flex flex-column align-center">
              <div class="logo flex flex-column align-center">
                <img src="../assets/image/icon.png" />
                <span>国家碳计量中心</span>
                <span>（福建）</span>
              </div>
              <div class="qrcode flex flex-column align-center">
                <img src="../assets/image/icon4.jpg" />
                <span>扫码关注我们</span>
              </div>
            </div>
          </b-col>
          <b-col xl="8" class="d-sm-none d-xl-block">
            <div class="footer-right flex">
              <div v-for="(item, index) in menuList" :key="index" class="footer-menu-list-item">
                <div class="footer-menu-list-item-title" @click="clickMenu(index,0)">{{ item.title }}</div>
                <div v-for="(child, cIndex) in (item.list || [])" :key="cIndex + 99" class="footer-menu-list-item-child" @click="clickMenu(cIndex,1,index)">
                  {{ child.title }}
                </div>
              </div>
            </div>
          </b-col>
          <b-col sm="8" class="d-sm-block d-xl-none">
            <div class="sm-footer-right">
              <div class="sm-footer-info">
                <span>版权所有：</span>
                <span>国家碳计量中心（福建）</span>
              </div>
              <div class="sm-footer-info">
                <span>地址：</span>
                <span>{{ concatInfo.company_address }}</span>
              </div>
              <div class="sm-footer-info">
                <span>邮编：</span>
                <span>{{ concatInfo.company_code }}</span>
              </div>
              <div class="sm-footer-info">
                <span>电话：</span>
                <span>{{ concatInfo.company_phone }}</span>
              </div>
              <div class="sm-footer-info">
                <span>{{ concatInfo.record }}</span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col xl="12" class="d-sm-none d-xl-block">
            <div class="footer-bottom">
              国家碳计量中心（福建）
            </div>
          </b-col>
          <b-col xl="12" class="d-sm-none d-xl-block">
            <div class="footer-bottom">
              邮编：{{ concatInfo.company_code }} 电话：{{ concatInfo.company_phone }} 邮箱：{{ concatInfo.company_email }} 地址：{{ concatInfo.company_address }}
            </div>
          </b-col>
          <b-col sm="12" class="d-sm-block d-xl-none">
            <div class="sm-footer-bottom flex flex-column align-center">
              <!-- <span>Copyrights © 2017 by zhiyundongneng </span> -->
              <span> 福建空天碳科技集团有限公司</span>
              <!-- 版权所有 闽ICP备XXXXXXXXXX号 -->
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { getContactUs } from "@/api/contactUs"
import { Row } from "element-ui";
export default {
  name: 'Footer',
  data() {
    return {
      menuList: [{
        title: '首页',
        name: 'home',
        url: '/'
      }, {
        title: '中心概况',
        name: 'overview',
        list: [{
          title: '中心简介'
        }, {
          title: '领导简介'
        }, {
          title: '产业布局'
        }, {
          title: '业务范围'
        }, {
          title: '发展规划'
        }, {
          title: '荣誉与成就'
        }, {
          title: '社会责任'
        }],
        url: '/overview',
      }, {
        title: '新闻动态',
        name: 'news',
        list: [{
          title: '中心资讯'
        }, {
          title: '最新新闻'
        }, {
          title: '行业动态'
        }, {
          title: '通知公告'
        }],
        url: '/news'
      }, {
        title: '组织建设',
        name: 'orga',
        list: [{
          title: '党群动态'
        }, {
          title: '党建活动'
        }, {
          title: '培训学习'
        }],
        url: '/organizational',
      }, {
        title: '业务领域',
        name: 'bussiness',
        list: [{
          title: '产品与服务'
        }, {
          title: '技术与创新'
        }, {
          title: '行业动向'
        }],
        url: '/bussiness'
      }, {
        title: '联系我们',
        name: 'contactUs',
        list: [{
          title: '留言'
        }, {
          title: '联系方式'
        }, {
          title: '交通指南'
        }],
        url: '/contactUs'
      }, {
        title: '人才招聘',
        name: 'recruit',
        url: '/recruit',
        list: [{
          title: '招聘公告'
        }, {
          title: '结果公示'
        }]
      }],
      concatInfo: {}
    }
  },
  mounted() {
    this.getContactUs()
  },
  methods: {
    getContactUs() {
      getContactUs().then(res => {
        // console.log(res)
        if (res.code == 200) {
          let obj = res.data.find(v => v.name == '联系方式') || { list: [{}] }
          this.concatInfo = obj.list[0]
        }
      })
    },
    clickMenu(index, type, pindex) {
      if (type == 0) {
        this.$router.push({ path: this.menuList[index].url })
      } else {
        if (this.menuList[pindex].name == this.$route.name) {
          let detailFlag = false
          if (this.$route.path == '/newsDetail' || this.$route.path == '/newsList' || this.$route.path == '/recruitDetail') {
            detailFlag = true
          }
          if (!detailFlag) {
            // 当前页面
            this.$emit('goScroll', index)
          } else {
            this.$router.push({ path: this.menuList[pindex].url + '?to=' + index })
          }
        } else {
          this.$router.push({ path: this.menuList[pindex].url + '?to=' + index })
        }
      }
    },
  }
}
</script>

<style scoped lang="scss">
.footer-line {
  background: #fff;
  border-top: 1px solid rgba(112, 112, 112, 0.1);
  .footer {
    max-width: 1440px;
    margin: 0 auto;
    padding: 10px 0;
  }

  .foot-left,
  .sm-foot-left {
    .logo {
      img {
        width: 120px;
        height: 88px;
      }

      span {
        font-family: "YouSheBiaoTiHei";
        font-size: 12px;
        color: rgba(51, 51, 51, 0.5);
        margin-top: 5px;
        text-align: center;
      }
    }

    .phone {
      margin: 30px 0 20px 0;

      img {
        width: 20px;
        height: 20px;
      }

      span {
        font-family: "SourceHanSansCN-Regular";
        font-weight: 400;
        font-size: 16px;
        color: rgba(51, 51, 51, 0.5);
        margin-left: 7px;
      }
    }

    .qrcode {
      img {
        width: 76px;
        height: 74px;
      }

      span {
        font-family: "SourceHanSansCN-Regular";
        font-weight: 400;
        font-size: 14px;
        color: rgba(102, 102, 102, 0.5);
        text-align: center;
        margin-top: 15px;
      }
    }
  }

  .footer-right {
    user-select: none;

    .footer-menu-list-item {
      flex: 1;
      flex-shrink: 0;

      &-title {
        padding: 20px 0 10px 0;
        font-family: "SourceHanSansCN-Regular";
        font-weight: 400;
        font-size: 14px;
        // color: rgba(51, 51, 51, 0.5);
        color: #333;
        cursor: pointer;
      }

      &-child {
        font-family: "SourceHanSansCN-Regular";
        font-weight: 400;
        font-size: 12px;
        // color: rgba(102, 102, 102, 0.5);
        color: #666;
        padding-top: 10px;
        cursor: pointer;
      }
    }
  }

  .footer-bottom {
    font-family: "SourceHanSansCN-Regular";
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 18px;
    text-align: center;
  }
}

.sm-foot-left {
  margin-top: 75px;

  .logo {
    span {
      font-family: "SourceHanSansCN-Regular" !important;
    }

    span:last-of-type {
      margin-top: 0 !important;
      margin-bottom: 17px !important;
    }
  }
}

.sm-footer-right {
  margin-top: 100px;
  .sm-footer-info {
    font-family: "SourceHanSansCN-Regular";
    font-weight: 400;
    font-size: 20px;
    line-height: 30px;
    margin-top: 25px;

    span:last-of-type {
      color: rgba(51, 51, 51, 1);
    }

    span:first-of-type {
      color: rgba(102, 102, 102, 1);
    }
  }
}

.sm-footer-bottom {
  font-family: "SourceHanSansCN-Regular";
  font-weight: 400;
  font-size: 20px;
  color: #999999;
  line-height: 30px;
  padding: 20px 0 40px 0;
  border-top: 2px solid rgb(233, 233, 233);
  margin-top: 20px;
}
@media (min-width: 576px) and (max-width: 1200px) {
  .sm-foot-left {
    span {
      font-size: 20px !important;
      line-height: 34px;
    }
    .qrcode {
      img {
        width: 102px !important;
        height: 102px !important;
      }
    }
  }
}
</style>
